import { render, staticRenderFns } from "./actuals_stats.vue?vue&type=template&id=134ee041&scoped=true&"
import script from "./actuals_stats.vue?vue&type=script&lang=js&"
export * from "./actuals_stats.vue?vue&type=script&lang=js&"
import style0 from "./actuals_stats.vue?vue&type=style&index=0&id=134ee041&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134ee041",
  null
  
)

export default component.exports